import { Link } from "react-router-dom";
import { useUser } from "../hooks/useAuthCompat";
import { BookOpen, Crown, Dumbbell, UserCircle } from "lucide-react";

const CARDS = [
  { to: "/library", label: "My Library", desc: "Books, audiobooks & learning progress", icon: BookOpen, testId: "library" },
  { to: "/vault", label: "Gold Vault", desc: "Signals, episodes, videos & frameworks", icon: Crown, testId: "gold-vault" },
  { to: "/themuscleschool/dashboard", label: "The Muscle School", desc: "Curriculum, lessons & reflections", icon: Dumbbell, testId: "muscle-school" },
  { to: "/account", label: "Account & Billing", desc: "Profile, subscriptions & purchase history", icon: UserCircle, testId: "account" },
];

export default function CustomerDashboard() {
  const { isSignedIn, isLoaded } = useUser();

  if (!isLoaded) return <div className="min-h-[60vh]" data-testid="dashboard-loading" />;

  if (!isSignedIn) {
    return (
      <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="dashboard-signed-out">
        <p className="text-white/60 mb-4">Sign in to view your dashboard.</p>
        <Link to="/sign-in" data-testid="dashboard-signed-out-sign-in-link" className="underline text-sm">Sign In</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16" data-testid="customer-dashboard-page">
      <p className="text-xs uppercase tracking-[0.2em] text-textSecondary mb-2">Your Dashboard</p>
      <h1 className="font-display text-display-md md:text-display-lg font-medium mb-10">Welcome Back</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {CARDS.map(({ to, label, desc, icon: Icon, testId }) => (
          <Link
            key={label}
            to={to}
            data-testid={`dashboard-card-${testId}`}
            className="group border border-white/10 bg-white/[0.02] hover:bg-white/[0.05] transition-colors duration-200 p-6 flex flex-col gap-4"
          >
            <Icon className="w-6 h-6 text-brandAccent" />
            <div>
              <p className="text-base font-medium">{label}</p>
              <p className="text-sm text-white/60 mt-1">{desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
